module.exports = __webpack_public_path__ + "components/alert-table/static/icon-delete-69ed8fae4d23d4ca03351392c1fe0b89.svg";